module.exports = __webpack_public_path__ + "img/activity_description2.b3d2940c.png";